import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Inject,
    OnInit,
    Output
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SwResetOptionComponent } from '../../../ui-components/select/sw-reset-option.component';
import { DatePickerComponent } from '../../../ui-components/date-picker/date-picker.component';
import { SearchInputComponent } from '../../../ui-components/search-input/search-input.component';
import { KeyValue } from '@angular/common';
import { Timestamp } from '@ngx-grpc/well-known-types';
import {
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { FilterStateService } from './filter-state.service';
import { FormControl } from '@angular/forms';
import { LogRequest } from '../../../protos/generated/admin.pb';

@Component({
    selector: 'app-filters-dialog',
    imports: [
        SwResetOptionComponent,
        DatePickerComponent,
        SearchInputComponent,
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        MatButton
    ],
    templateUrl: './filters-dialog.component.html',
    styleUrl: './filters-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiltersDialogComponent implements OnInit {
    @Output() filtersUpdated = new EventEmitter<LogRequest>();

    severityList: KeyValue<string, string>[] = [
        { value: 'None', key: '0' },
        { value: 'Debug', key: '1' },
        { value: 'Information', key: '2' },
        { value: 'Warning', key: '3' },
        { value: 'Error', key: '4' },
        { value: 'Fatal', key: '5' }
    ];
    logRequest: LogRequest;
    updatedFilters!: LogRequest;
    formatedStartDate = new FormControl<Date | null>(null);
    formatedEndDate = new FormControl<Date | null>(null);

    ngOnInit(): void {

        this.filterStateService.filterState$.subscribe(
            (filters: LogRequest) => {
                this.updatedFilters = filters;
                //change format of start date to bind it to the form
                this.formatedStartDate.setValue(
                    this.updatedFilters.startTime
                        ? this.getDateFromTimestamp(
                              this.updatedFilters.startTime
                          )
                        : null
                );
                //change format of end date to bind it to the form
                this.formatedEndDate.setValue(
                    this.updatedFilters.endTime
                        ? this.getDateFromTimestamp(
                              this.updatedFilters.endTime
                          )
                        : null
                );
               
            }
        );
    }

    constructor(
        public dialogRef: MatDialogRef<FiltersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { logRequest: LogRequest },
        private filterStateService: FilterStateService // Add the service here
    ) {
        this.logRequest = new LogRequest();
        Object.assign(this.logRequest, data.logRequest); // Initialize with the passed-in data
    }

    resetFilters(event: any) {
        event.preventDefault();
        this.filterStateService.setFilterState(new LogRequest())
        this.logRequest = this.filterStateService.getFilterState()
        
    }

    onSeverityChange(severity: string) {
        this.logRequest.severity = parseInt(severity);
    }

    onStartDateChange(startDate: any) {
        const startTime = new Timestamp();
        startTime.seconds = Math.floor(startDate / 1000).toString();
        startTime.nanos = (startDate % 1000) * 1000000;
        this.logRequest.startTime = startTime;
    }

    onEndDateChange(endDate: any) {
        const endTime = new Timestamp();
        endTime.seconds = Math.floor(endDate / 1000).toString();
        endTime.nanos = (endDate % 1000) * 1000000;
        this.logRequest.endTime = endTime;
    }

    onSearchSourceContext(search: string) {
        this.logRequest.sourceContext = search;
    }

    onSearchFilter(search: string) {
        this.logRequest.filter = search;
    }
    onSearchMethod(search: string) {
        this.logRequest.method = search;
    }
    onSearchId(search: number) {
        this.logRequest.id = search;
    }

    applyFilters(event: Event) {
        event.preventDefault();
        this.filterStateService.setFilterState(this.logRequest); // Save state to service
        this.dialogRef.close(this.logRequest);
    }
    cancel(event: Event) {
        event.preventDefault();
        this.dialogRef.close();
    }

    getDateFromTimestamp(timestamp: Timestamp): Date {
        const milliseconds =
            parseInt(timestamp.seconds) * 1000 + timestamp.nanos / 1000000;
        return new Date(milliseconds);
    }
}
